$(document).ready(function() {
    var fullScreen = false;

    if (!document.fullscreenEnabled) {
        $('#full-screen-vm').hide();
    } else {
        var exitHandler = function() {
            if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                var fullScreenBtn = $('#full-screen-vm');
                fullScreen = false;
                fullScreenBtn.find('.icon-fullscreen').show();
                fullScreenBtn.find('.icon-fullscreen-off').hide();
            }
        };

        document.addEventListener('fullscreenchange', exitHandler);
        document.addEventListener('webkitfullscreenchange', exitHandler);
        document.addEventListener('mozfullscreenchange', exitHandler);
        document.addEventListener('MSFullscreenChange', exitHandler);
    }

    $('#full-screen-vm').on('click', function () {
        var btn = $(this),
            el = $('#vm-control')[0];

        if (fullScreen) {
            document.exitFullscreen().then(function() {
                fullScreen = false;
                btn.find('.icon-fullscreen').show();
                btn.find('.icon-fullscreen-off').hide();
            });
        } else {
            var potentialMethods = [
                'requestFullscreen',
                'webkitRequestFullscreen',
                'mozRequestFullScreen',
                'msRequestFullscreen',
            ];

            var found = false;

            potentialMethods.forEach(function (item) {
                if (item in el && !found) {
                    el[item]().then(function () {
                        fullScreen = true;
                        btn.find('.icon-fullscreen-off').show();
                        btn.find('.icon-fullscreen').hide();
                    });
                    found = true;
                }
            });
        }
    });

    $('.announcement-alert').on('closed.bs.alert', function () {
        var baseUrl = $('body').data('base-url');

        $.post(baseUrl + '/dismiss-announcement', {
            uuid: $(this).data('uuid')
        });
    });

    var focusFirst;

    $(".search-query form").submit(function() {
        var lastChar,
            baseUrl = $(this).attr('action'),
            search = $("#search-term").val();

        if (search.length > 0) {
            lastChar = baseUrl[baseUrl.length - 1];
            if (lastChar !== '/') {
                baseUrl += '/';
            }

            window.location = baseUrl + 'search/' + search;
        }

        return false;
    });

    $('.row-hover-check tr').click(function() {
        var checkbox = $(this).find('input[type=checkbox]');

        checkbox.prop('checked', !checkbox.prop('checked'));
    });

    $('.select2').select2();

    $(".reboot-trigger, .shutdown-trigger").click(function() {
        var modal = $($(this).attr('href')),
            data = $(this).data(),
            urlBtn = modal.find('.action-url'),
            name = modal.find('.machine-name');

        name.text(data.name);
        urlBtn.attr('href', data.url);
    });

    $('a.disabled').click(function(e) {
        e.preventDefault();
        return false;
    });

    $('.multiselect').selectpicker();

    window.supportsWebSockets = function () {
        return "WebSocket" in window;
    };

    if (!window.supportsWebSockets()) {
        $('#browserFail').removeClass('hidden');
    }

    focusFirst = function (formSelector) {
        var form = $(formSelector);
        if (form.length) {
            form.find('input')[0].focus();
        }
    };

    focusFirst('#login');
    focusFirst('#two-factor');

});
